import React from "react";
import { withStyles } from "@material-ui/styles";
import { get, map } from "lodash";

import Grid from "@material-ui/core/Grid";

import {
  activeCases,
  failedSurveys,
  feverdetected,
} from "../../../constants/common";

const styles = {
  bar: {
    height: "14px",
    marginBottom: "2px",
  },
  barCount: {
    marginLeft: "5px",
    height: "14px",
    lineHeight: "14px",
  },
};

const HspChartValue = (props) => {
  const { classes, item, barColors, maxValue } = props;

  const total = item.activeCases + item.failedSurveys + item.feverdetected;

  return (
    <Grid item style={{ marginBottom: "15px" }}>
      <Grid container direction="column" style={{ paddingLeft: "20px" }}>
        <Grid item className="text-87">
          <Grid container alignItems="center" wrap="nowrap">
            <Grid item>{get(item, ["name"])}</Grid>
            <Grid item style={{ marginLeft: "10px" }}>
              ({total})
            </Grid>
          </Grid>
        </Grid>
        {map([activeCases, failedSurveys, feverdetected], (type, index) => (
          <Grid item key={index}>
            <Grid container wrap="nowrap">
              <Grid
                item
                className={classes.bar}
                style={{
                  backgroundColor: get(barColors, [index]),
                  width: `calc(${Math.round(
                    (get(item, [type]) / maxValue) * 100
                  )}% - 10px)`,
                  minWidth: "2px",
                }}
              />
              <Grid item className={classes.barCount}>
                {get(item, [type])}
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(HspChartValue);
